import React from "react";
import "./app.css";
import { getImage } from "../../../../../../utils/getImages";
const StoryCard = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="col-md-12 text-center py-5">
        <h1 className="title px-3 px-md-0 mt-10" style={{fontWeight:"bold",color:"gray"}}>
          {activetab === "english"
            ? cardData?.title
            : activetab === "simplified_chinese"
            ? cardData?.simplified_chinese_title
            : activetab === "arabic"
            ? cardData?.arabic_title
            : cardData?.traditional_chinese_title}
        </h1>
        <div
          id="icon-lists"
          className="row align-items-center"
          style={{ marginTop: "20px" }}
        >
          {cardData?.dataArray?.map((item) => (
            <div className="col-6 col-md-3">
              <div className="text-center">
                <img style={{width:"100%",height:"200px",borderRadius:"10px"}}
                  src={
                    getImage(activetab === "english"
                      ? item?.image
                      : activetab === "simplified_chinese"
                      ? item?.simplified_chinese_image
                      : activetab === "arabic"
                      ? item?.arabic_image
                      : item?.traditional_chinese_image)
                   }
                  alt=""
                />
                <p data-lang='{ "CN":"150,695 噸" }'>
                  {" "}
                  {activetab === "english"
                    ? item?.title
                    : activetab === "simplified_chinese"
                    ? item?.simplified_chinese_title
                    : activetab === "arabic"
                    ? item?.arabic_title
                    : item?.traditional_chinese_title}
                </p>
           
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoryCard;
